import { Maybe } from 'types/graphqlTypes'
import { TSavedLaneSchema } from '../schema'
import { IDateTypes } from '../types'

interface IGetSavedLaneSchemaDateType {
  pickupIsoDaysOfWeek: Maybe<number[]>
  pickupStartDate: Maybe<string>
}

/**
 * Returns a SavedLaneSchema dateType value based off pickup ISO weekdays and pickup start date
 *
 * @example getSavedLaneSchemaDateType({pickupIsoDaysOfWeek: null, pickupStartDate: null}) // IDateTypes.anyDay
 * @example getSavedLaneSchemaDateType({pickupIsoDaysOfWeek: [1], pickupStartDate: null}) // IDateTypes.daysOfWeek
 * @example getSavedLaneSchemaDateType({pickupIsoDaysOfWeek: null, pickupStartDate: '2023-01-01'}) // IDateTypes.specificDates
 */
export const getSavedLaneSchemaDateType = ({
  pickupIsoDaysOfWeek = [],
  pickupStartDate,
}: IGetSavedLaneSchemaDateType): TSavedLaneSchema['dateType'] => {
  if (!pickupIsoDaysOfWeek && !pickupStartDate) {
    return IDateTypes.anyDay
  }

  if (pickupStartDate) {
    return IDateTypes.specificDates
  }

  const numberOfPickupDays = pickupIsoDaysOfWeek?.length || 0

  if (numberOfPickupDays > 0 && numberOfPickupDays < 7) {
    return IDateTypes.daysOfWeek
  }

  return IDateTypes.anyDay
}
